import { PERMISSION_BY_ROLE } from 'Utils/permissionByRol'
import {
  ROLE_ADMIN_DISPLAY,
  ROLE_DEVELOPER_DISPLAY,
  ROLE_OPERATION_MANAGER_DISPLAY,
  ROLE_PRODUCT_OWNER_DISPLAY
} from 'constant/roles'

export const LIST_ROLE_FILTER_USER = {
  header: 'Role',
  options: [
    { option: ROLE_ADMIN_DISPLAY, allowed: PERMISSION_BY_ROLE.USER.FILTER_BY_ROLE.BY_ADMIN },
    { option: ROLE_OPERATION_MANAGER_DISPLAY, allowed: PERMISSION_BY_ROLE.USER.FILTER_BY_ROLE.BY_OPM },
    {
      option: ROLE_PRODUCT_OWNER_DISPLAY,
      allowed: PERMISSION_BY_ROLE.USER.FILTER_BY_ROLE.BY_PO
    },
    {
      option: ROLE_DEVELOPER_DISPLAY,
      allowed: PERMISSION_BY_ROLE.USER.FILTER_BY_ROLE.BY_DEV
    }
  ]
}
